import {
 
  ExportOutlined,
  
  ImportOutlined,
  
  PushpinOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import {
  Row,
  Col,
  
  Card,
  Select,
  Input,
  Radio,
  Button,
  Space,
  Form,
  
  Table,
  notification,
 
  Tag,
  Upload,
  Modal,
} from "antd";
import * as XLSX from "xlsx";
import { useEffect, useState } from "react";
import "../Pages/CSS/DonnesBases.css";

import { TableauOrdreService } from "../Services/TableauOrdreService";
import { SpecialitesService } from "../Services/SpecialitesService";

const { Option } = Select;

const TableauOrdre = () => {
  const initialTableData = [];
  const [showEditForm, setShowEditForm] = useState(false);
  const [totalFournisseurs, setTotalFournisseurs] = useState(0);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [specialitesData, setSpecialitesData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const [showCreateDivButton, setShowCreateDivButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("a");
  const [tableData, setTableData] = useState(initialTableData);
  const [filteredData, setFilteredData] = useState(initialTableData);
  const [form] = Form.useForm();
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedFournisseur, setSelectedFournisseur] = useState(null);

  const tableauOrdreService = new TableauOrdreService();
  const specialitesService = new SpecialitesService();
  useEffect(() => {
    setLoading(true);
    tableauOrdreService
      .getAllTableauOrdre()
      .then((data) => {
        setTableData(data);
        setTotalFournisseurs(data.length); // Met à jour le nombre total de fournisseurs
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setFilteredData(tableData); // Initialisation des données filtrées avec les données complètes au chargement
  }, [tableData]);

  const fetchSpecialite = async () => {
    try {
      const specialites = await specialitesService.getAllSpecialites();
      setSpecialitesData(specialites);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  // Filtre recherche
  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Mettre à jour les données filtrées
  };

  // Actualisation
  const handleResetAll = async () => {
    try {
      const updatedData = await tableauOrdreService.getAllTableauOrdre(); // Récupère les nouvelles données
      setTableData(updatedData); // Met à jour le tableau avec les nouvelles données
      setSelectedRowData(null); // Réinitialise les données sélectionnées
    } catch (error) {}
  };

  useEffect(() => {
    if (selectedOption === "a") {
      setFilteredData(tableData); // Affiche toutes les données si l'option est "Tout"
    } else if (selectedOption === "c") {
      const filteredPharmacy = tableData.filter(
        (item) => item.specialisation.toLowerCase() === "pharmacie"
      );
      setFilteredData(filteredPharmacy);
    } else if (selectedOption === "d") {
      const filteredDentist = tableData.filter(
        (item) => item.specialisation.toLowerCase() === "dentiste"
      );
      setFilteredData(filteredDentist);
    } else {
      const filteredMedicine = tableData.filter(
        (item) =>
          item.specialisation.toLowerCase() !== "pharmacie" &&
          item.specialisation.toLowerCase() !== "dentiste"
      );
      setFilteredData(filteredMedicine);
    }
  }, [selectedOption, tableData]);

  const handleRowClick = (record) => {
    setSelectedRowData(record);
    setShowEditForm(true);
  };

  useEffect(() => {
    setTotalFournisseurs(calculateTotalFournisseurs(filteredData));
  }, [filteredData]);

  const calculateTotalFournisseurs = (data) => {
    return data.length;
  };

  useEffect(() => {
    // Vérifie si selectedRowData est défini et le formulaire existe avant de mettre à jour les champs
    if (selectedRowData && form) {
      form.setFieldsValue({
        libacte: selectedRowData.libacte,
        tarif: selectedRowData.tarif,
        // codeprest: selectedRowData.codeprest,
        exclus: selectedRowData.exclus,
        lettre_cle: selectedRowData.lettre_cle,
        coef: selectedRowData.coef,
      });
    }
  }, [selectedRowData, form]);

  useEffect(() => {
    if (selectedOption === "e") {
      setShowCreateDivButton(true); // Afficher le bouton si l'option est "Non agrées"
    } else {
      setShowCreateDivButton(false); // Cacher le bouton pour les autres options
    }
  }, [selectedOption]);


  const handleExcelImport = (file) => {
    console.log("File selected:", file);
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, {
        type: rABS ? "binary" : "array",
        bookVBA: true,
      });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

      // 'data' now contains the imported Excel data, you can process it as needed
      console.log(data);
    };

    if (rABS) {
      reader.readAsBinaryString(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  };

  const exportToXLSX = (data) => {
    if (!data || data.length === 0) {
      notification.error({
        message: "Erreur d'exportation",
        description: "Aucune donnée disponible à exporter.",
      });
      return;
    }

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");
    XLSX.writeFile(wb, "tableau_ordre_export.xlsx");
  };

  const handleExport = () => {
    exportToXLSX(filteredData);
  };

  const columns = [
    {
      title: "N°",
      dataIndex: "numero",
      align: "center",
      key: "numero",
      className: "small-cell",
      ellipsis: true,
      render: (text) => <strong>{text || " "}</strong>,
      sorter: (a, b) => (String(a.numero) || "").localeCompare(String(b.numero) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "N° Carte",
      dataIndex: "num_carte",
      key: "num_carte",
      align: "center",
      className: "small-cell",
      ellipsis: true,
      render: (text) => text || " ", // Gérer les valeurs null ou undefined
      sorter: (a, b) => (a.num_carte || "").localeCompare(b.num_carte || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            paddingLeft: 5,
          }}
        >
          Prénom
        </div>
      ),
      dataIndex: "prenoms",
      key: "prenoms",
      className: "small-cell",
      ellipsis: true,
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingRight: 5, paddingLeft: 5 }}>
          {text || " "}
        </div>
      ),
      sorter: (a, b) => (a.prenoms || "").localeCompare(b.prenoms || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            paddingLeft: 5,
          }}
        >
          Nom
        </div>
      ),
      dataIndex: "nom",
      key: "nom",
      className: "small-cell",
      ellipsis: true,
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingRight: 5, paddingLeft: 5 }}>
          {text || " "}
        </div>
      ),
      sorter: (a, b) => (a.nom || "").localeCompare(b.nom || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            paddingLeft: 5,
          }}
        >
          Adresse
        </div>
      ),
      dataIndex: "adresse_pro",
      key: "adresse_pro",
      className: "small-cell",
      ellipsis: true,
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingRight: 5, paddingLeft: 5 }}>
          {text || " "}
        </div>
      ),
      sorter: (a, b) => (a.adresse_pro || "").localeCompare(b.adresse_pro || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "N° Tel.",
      dataIndex: "num_telephone",
      key: "num_telephone",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      render: (text) => text || " ", // Gérer les valeurs null ou undefined
      sorter: (a, b) => (a.num_telephone || "").localeCompare(b.num_telephone || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Section",
      dataIndex: "section",
      key: "section",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      render: (text) => text || " ", // Gérer les valeurs null ou undefined
      sorter: (a, b) => (a.section || "").localeCompare(b.section || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            paddingLeft: 5,
          }}
        >
          Spécialisation
        </div>
      ),
      dataIndex: "specialisation",
      key: "specialisation",
      className: "small-cell",
      ellipsis: true,
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingRight: 5, paddingLeft: 5 }}>
          {text || " "}
        </div>
      ),
      sorter: (a, b) => (a.specialisation || "").localeCompare(b.specialisation || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Agréé",
      dataIndex: "agree",
      key: "agree",
      className: "small-cell",
      ellipsis: true,
      fixed:"right",
      align: "center",
      render: (text, record) => (
        <span>
          {text === "Non" ? <Tag color="red">Non</Tag> : <Tag>Oui</Tag>}
          <PushpinOutlined
            style={{ marginLeft: "5px", color: "blue" }}
            onClick={() => handleOpenModal(record)} // Appel de la fonction pour ouvrir le modal
          />
        </span>
      ),
      sorter: (a, b) => (a.agree || "").localeCompare(b.agree || ""),
      sortDirections: ["ascend", "descend"],
    },
  ];
  

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: [
      Table.SELECTION_ALL,
      Table.SELECTION_INVERT,
      Table.SELECTION_NONE,
    ],
  };

  useEffect(() => {
    if (selectedType !== "") {
      const filteredByType = tableData.filter(
        (item) => item.codespe === selectedType
      );
      setFilteredData(filteredByType);
    } else {
      setFilteredData(tableData);
    }
  }, [selectedType, tableData]);

  const handleOpenModal = (record) => {
    setSelectedFournisseur(record);
    setModalVisible(true);
    fetchSpecialite();
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    setSelectedFournisseur(null);
  };

  const handleModalSubmit = async (values) => {
    // Construction du payload à partir des valeurs du formulaire et des données du fournisseur sélectionné
    const payload = {
      adresse_pro: selectedFournisseur.adresse_pro,
      agree: "A", // Assurez-vous que cette valeur est dynamique selon vos besoins
      codeSpe: values.codespe, // Assurez-vous que le nom du champ correspond à votre Form.Item
      nom: selectedFournisseur.nom,
      nom_structure: selectedFournisseur.nom_structure,
      num_carte: selectedFournisseur.num_carte,
      num_telephone: selectedFournisseur.num_telephone,
      numero: selectedFournisseur.numero,
      prenoms: selectedFournisseur.prenoms,
      region: selectedFournisseur.region,
      section: selectedFournisseur.section,
      specialisation: selectedFournisseur.specialisation,
      ville: selectedFournisseur.ville
    };
  
    try {
      await tableauOrdreService.addAgree(payload);
      notification.success({
        message: 'Succès',
        description: 'Le fournisseur a été agréé avec succès.'
      });
      handleCloseModal(); // Fermer le modal après la soumission réussie
      handleResetAll(); // Actualiser les données du tableau si nécessaire
    } catch (error) {
      notification.error({
        message: 'Erreur',
        description: 'Une erreur est survenue lors de l\'agrément du fournisseur.'
      });
    }
  };
  

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={24}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={8} lg={8}>
              <label>Total fournisseurs : {totalFournisseurs}</label>
              <Row gutter={8} align="middle" padding>
                <Col xs={12}>
                  <Input
                    placeholder="Recherche..."
                    bordered={false}
                    style={{ borderBottom: "1px solid #ccc" }}
                    onChange={(e) => handleSearch(e.target.value)}
                    onPressEnter={(e) => handleSearch(e.target.value)}
                  />
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={16} lg={16}>
              <Row justify="end">
                <Col span={24} style={{ textAlign: "right" }}>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: "1rem" }}>
                    {[
                      { value: "a", label: "Tout" },
                      { value: "b", label: "Medecins" },
                      { value: "c", label: "Pharmaciens" },
                      { value: "d", label: "Dentistes" },
                    ].map((item) => (
                      <button
                        key={item.value}
                        onClick={() => setSelectedOption(item.value)}
                        style={{
                          padding: "6px 14px",
                          borderRadius: 20,
                          border: "none",
                          cursor: "pointer",
                          fontSize: 13,
                          fontWeight: 500,
                          transition: "all 0.3s ease",
                          background: selectedOption === item.value
                            ? "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)"
                            : "#f0f0f0",
                          color: selectedOption === item.value ? "#fff" : "#595959",
                          boxShadow: selectedOption === item.value
                            ? "0 3px 10px rgba(24, 144, 255, 0.4)"
                            : "0 1px 3px rgba(0, 0, 0, 0.1)",
                        }}
                        onMouseEnter={(e) => {
                          if (selectedOption !== item.value) {
                            e.currentTarget.style.background = "#e0e0e0";
                            e.currentTarget.style.transform = "translateY(-1px)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (selectedOption !== item.value) {
                            e.currentTarget.style.background = "#f0f0f0";
                            e.currentTarget.style.transform = "translateY(0)";
                          }
                        }}
                      >
                        {item.label}
                      </button>
                    ))}
                  </div>
                </Col>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Space
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Upload
                      beforeUpload={(file) => {
                        handleExcelImport(file);
                        return false; // Prevent upload
                      }}
                      accept=".xlsx, .xls"
                    >
                      <Button
                        type="file"
                        className="buttonImport"
                        size="small"
                        icon={<ImportOutlined />}
                      >
                        Import Excel
                      </Button>
                    </Upload>
                    <Button
                      onClick={handleExport}
                      icon={<ExportOutlined />}
                      size="small"
                      className="buttonExport"
                    >
                      Exporter Excel
                    </Button>
                    <Button
                      onClick={handleResetAll}
                      icon={<SyncOutlined />}
                      size="small"
                     // style={{ backgroundColor: "#67f02e", color: "white" }}
                     className="buttonRefresh" 
                    >
                      Actualiser
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Col>
          </Row>

          <Card bordered={false}>
            <Table
              rowSelection={rowSelection}
              rowKey={(record) => record.numero}
              scroll={{
                x: true,
              }}
              className="custom-header1-table"
              bordered
              showSorterTooltip={false}
              columns={columns}
              dataSource={filteredData}
              onRow={(record) => ({
                onClick: () => handleRowClick(record),
              })}
              loading={loading}
            />
          </Card>
        </Col>
      </Row>
      <Modal
        open={modalVisible}
        maskClosable={false}
        title={`Agrément Medecin n° ${selectedFournisseur?.numero}`}
        onCancel={handleCloseModal}
        footer={[
          <Button key="back" className="buttonClose" onClick={handleCloseModal}>
            Annuler
          </Button>,
          <Button
            key="submit"
            type="primary"
            className="Buttonvalid"
            onClick={() => form.submit()}
          >
            Enregistrer
          </Button>,
        ]}
      >
        <h3>{`${selectedFournisseur?.prenoms} ${selectedFournisseur?.nom}`}</h3>
        <Form
          form={form}
          layout="vertical"
          name="speciality_form"
          onFinish={handleModalSubmit}
        >
          <Form.Item
            name="codespe"
            label="Veuillez selectionner une spécialité"
            rules={[
              {
                required: true,
                message: "Veuillez sélectionner une spécialité",
              },
            ]}
          >
            <Select
              showSearch
              bordered={false}
              style={{ borderBottom: "solid 1px black" }}
              placeholder="Sélectionner une spécialité"
            >
              {specialitesData &&
                specialitesData.map((specialite) => (
                  <Option key={specialite.codespe} value={specialite.codespe}>
                    {`${specialite.codespe} - ${specialite.intitule}`}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default TableauOrdre;
